module.exports = __webpack_public_path__ + "img/xtpt.18b727b8.png";